module.exports = __webpack_public_path__ + "img/VA2.f880b216.jpeg";